<template>
  <v-card>
    <v-card-title>
      ASOPAF
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="families"
      :search="search"
      :pagination.sync="pagination"
      :loading="loadingTable"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{props.item.id_user}} {{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.mother }}</td>
        <td class="text-xs-center">{{ props.item.father }}</td>
        <td class="text-xs-center">{{ props.item.email }}</td>
        <td>
          <v-checkbox
            :key="props.item.id_user"
            :name="`check_${props.item.id_user}`"
            :input-value="props.item.asopaf === 1"
            @change="handleAsopafCheckClick(props.item.id_user, props.item.id_info, props.item.asopaf !== 1)"
            color="primary"
          ></v-checkbox>
        </td>

      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>
<script>
import axios from 'axios'

export default {
  name: 'families-list-view',
  data() {
    return {
      search: '',
      pagination: {
        sortBy: 'asopaf',
        descending: true
      },
      headers: [
        { text: 'Familia', align: 'center', value: 'name' },
        { text: 'Madre', align: 'center', value: 'mother' },
        { text: 'Padre', align: 'center', value: 'father' },
        { text: 'email', align: 'center', value: 'email' },
        { text: 'ASOPAF', align: 'left', value: 'asopaf' }
      ],
      families: [],
      loadingTable: false
    }
  },
  created() {
    this.getAssembliesList()
  },
  methods: {
    async getAssembliesList() {
      this.loadingTable = true;
      const { data } = await axios.get('/api/families')
      this.families = data;
      this.loadingTable = false;
    },

    handleAsopafCheckClick(id_user, id_info, add) {
      if (add) {
        axios.post('api/family/asopaf/add', { id_info, id_user })
          .then(response => {
            if (response.status === 200) {
              this.families = this.families.map(family => {
                if (family.id_user === id_user) {
                  family.id_info = response.data.id_info;
                  family.asopaf = 1;
                }
                return family;
              })
            }
          })
          .catch(error => {

          });

        return;
      }

      axios.delete(`api/family/asopaf/remove/${id_info}`)
        .then(response => {
          if (response.status === 200) {
            this.families = this.families.map(family => {
              if (family.id_user === id_user) {
                family.asopaf = null;
              }
              return family;
            })
          }
        })
        .catch(error => {

        });
    }
  }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/pages/family/asopaf.vue